import LegalLayout, { LegalSection } from "@/components/LegalLayout";
import { OWNER } from "@/lib/legalContent";

export default function AvisoLegal() {
  return (
    <LegalLayout
      title="Aviso Legal"
      intro={`Información legal del sitio web de ${OWNER.name}, en cumplimiento de la Ley 34/2002, de Servicios de la Sociedad de la Información y de Comercio Electrónico (LSSICE).`}
    >
      <p>
        {OWNER.name} se reserva el derecho de modificar cualquier tipo de información que pudiera aparecer en el sitio
        web, sin que exista obligación de preavisar o poner en conocimiento de los usuarios dichas obligaciones,
        entendiéndose como suficiente con la publicación en el sitio web de {OWNER.name}.
      </p>
      <p>
        En cumplimiento del artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información
        y Comercio Electrónico, a continuación se exponen los datos identificativos de la titular del sitio web:
      </p>

      <LegalSection heading="1. Datos identificativos">
        <ul className="list-disc space-y-1.5 pl-5">
          <li><strong>Titular:</strong> {OWNER.name}</li>
          <li><strong>NIF:</strong> {OWNER.nif}</li>
          <li><strong>Domicilio:</strong> {OWNER.address}</li>
          <li><strong>Correo electrónico:</strong> <a className="text-primary underline underline-offset-2" href={`mailto:${OWNER.email}`}>{OWNER.email}</a></li>
          <li><strong>Teléfono:</strong> {OWNER.phoneLegal}</li>
          <li><strong>Actividad:</strong> Clínica podológica</li>
        </ul>
      </LegalSection>

      <LegalSection heading="2. Derechos de propiedad intelectual e industrial">
        <p>
          El sitio web, incluyendo a título enunciativo pero no limitativo su programación, edición, compilación y demás
          elementos necesarios para su funcionamiento, los diseños, logotipos, texto y/o gráficos, son propiedad de la
          titular o, si es el caso, dispone de licencia o autorización expresa por parte de los autores. Todos los
          contenidos del sitio web se encuentran debidamente protegidos por la normativa de propiedad intelectual e
          industrial.
        </p>
        <p>
          Independientemente de la finalidad para la que fueran destinados, la reproducción total o parcial, uso,
          explotación, distribución y comercialización, requiere en todo caso de la autorización escrita previa por
          parte de la titular. Cualquier uso no autorizado previamente se considera un incumplimiento grave de los
          derechos de propiedad intelectual o industrial.
        </p>
        <p>
          Los diseños, logotipos, texto y/o gráficos ajenos a la titular que pudieran aparecer en el sitio web,
          pertenecen a sus respectivos propietarios, siendo ellos mismos responsables de cualquier posible controversia
          que pudiera suscitarse respecto a los mismos.
        </p>
        <p>
          Para realizar cualquier observación respecto a posibles incumplimientos de los derechos de propiedad
          intelectual o industrial, así como sobre cualquiera de los contenidos del sitio web, puede hacerlo a través del
          correo electrónico <a className="text-primary underline underline-offset-2" href={`mailto:${OWNER.email}`}>{OWNER.email}</a> o
          en la dirección postal {OWNER.address}.
        </p>
      </LegalSection>

      <LegalSection heading="3. Navegación, acceso y seguridad">
        <p>
          El acceso, navegación y utilización de esta página web implica por tu parte la aceptación expresa y sin
          reservas de todos los términos del presente Aviso Legal, teniendo la misma validez y eficacia que cualquier
          contrato celebrado por escrito y firmado. Se entenderá por Usuario a la persona que acceda, navegue o utilice
          los servicios y actividades desarrolladas en el Sitio Web.
        </p>
        <p>
          {OWNER.name} realiza los máximos esfuerzos para que la navegación se realice en las mejores condiciones y
          evitar los perjuicios de cualquier tipo que pudiesen ocasionarse durante la misma. No obstante, no se
          responsabiliza ni garantiza que el acceso a este Sitio Web sea ininterrumpido o que esté libre de error.
        </p>
        <p>
          Queda prohibido el acceso a este Sitio Web por parte de menores de 14 años, salvo que cuenten con la
          autorización previa y expresa de sus padres, tutores o representantes legales, quienes serán considerados como
          responsables de los actos que lleven a cabo los menores a su cargo, conforme a la normativa vigente.
        </p>
      </LegalSection>

      <LegalSection heading="4. Exención de responsabilidades">
        <p>
          La titular se exime de cualquier tipo de responsabilidad derivada de la información publicada en su sitio web,
          siempre que esta información haya sido manipulada o introducida por un tercero ajeno al mismo.
        </p>
        <p>
          Este sitio web ha sido revisado y probado para que funcione correctamente. No obstante, no se descarta la
          posibilidad de que existan ciertos errores de programación, o que acontezcan causas de fuerza mayor,
          catástrofes naturales, huelgas o circunstancias semejantes que hagan imposible el acceso a la página web.
        </p>
      </LegalSection>

      <LegalSection heading="5. Política de enlaces">
        <p>
          Desde el sitio web es posible que se redirija a contenidos de terceros sitios web. Dado que la titular no puede
          controlar siempre los contenidos introducidos por terceros en sus respectivos sitios web, no asume ningún tipo
          de responsabilidad respecto a dichos contenidos. En todo caso, procederá a la retirada inmediata de cualquier
          contenido que pudiera contravenir la legislación nacional o internacional, la moral o el orden público.
        </p>
      </LegalSection>

      <LegalSection heading="6. Condiciones adicionales">
        <p>
          El usuario que introduce los datos es el responsable único y final de la veracidad de la información
          suministrada en el servicio y de las modificaciones de los mismos que pueda realizar.
        </p>
      </LegalSection>

      <LegalSection heading="7. Actualización y modificación de la información">
        <p>
          La información que aparece en este sitio web es la vigente en la fecha de su última actualización. {OWNER.name}
          {" "}se reserva el derecho a actualizar, modificar o eliminar la información de este sitio web, pudiendo limitar
          o no permitir el acceso al mismo, así como a efectuar en cualquier momento y sin previo aviso cuantos cambios y
          modificaciones estime convenientes.
        </p>
      </LegalSection>

      <LegalSection heading="8. Ley aplicable y jurisdicción">
        <p>
          Las presentes condiciones se regirán e interpretarán de acuerdo con la legislación común española. Para
          cuantas cuestiones pudieran surgir sobre la interpretación, cumplimiento, rescisión o resolución de las
          condiciones generales, las partes se someten a la jurisdicción y competencia de los Juzgados y Tribunales de
          {" "}{OWNER.jurisdiction}. No obstante, de conformidad con la legislación española, serán competentes los
          juzgados y tribunales del domicilio que resulte de aplicación conforme al artículo 52 de la Ley de
          Enjuiciamiento Civil o norma sustitutiva aplicable en cada momento.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
